import { prefetchRouteForPath } from './splashChrome';

/** Warm the first route chunk while splash is visible. */
export function prefetchInitialRoute() {
  if (typeof window === 'undefined') return;
  prefetchRouteForPath(window.location.pathname);
}
